const APP_GALLERY_OPEN_EVENT_TYPE = "app:product:openGallery";
const APP_GALLERY_CLOSE_EVENT_TYPE = "app:product:closeGallery";

function open(imageUrls, selectedImage) {
    const event = new Event(APP_GALLERY_OPEN_EVENT_TYPE);
    event.detail = {
        imageUrls,
        selectedImage
    };
    document.dispatchEvent(event);
}

function addOnClosedListener(onCloseListener) {
    document.addEventListener(APP_GALLERY_CLOSE_EVENT_TYPE, (event) => {
        onCloseListener?.(event.detail?.selectedImage);
    });
}

export default {
    open,
    addOnClosedListener
}
